import React from "react";

const KVContext = React.createContext(null);

export default KVContext